import { doc, setDoc } from "firebase/firestore";
import { auth, db, appId } from "../../firebase";
import { getAttendanceCheckedCount } from "./attendanceViewDataUtils";

export default function useAttendanceSave({
  currentDate,
  dailyAttendance,
  onRefreshLogs,
  onSaveAttendance,
  openAlert,
  savedCheckCount,
  setSavedCheckCount,
  userProfile,
}) {
  const handleSaveDaily = async () => {
    if (!auth.currentUser) {
      openAlert("로그인이 필요합니다.", "알림");
      return;
    }

    const checkCount = getAttendanceCheckedCount(dailyAttendance);

    if (auth.currentUser.isAnonymous) {
      const key = `attendance_${auth.currentUser.uid}_${currentDate}`;
      const existing = localStorage.getItem(key);
      const prevData = existing ? JSON.parse(existing) : {};
      const mergedData = { ...prevData, ...dailyAttendance };

      localStorage.setItem(key, JSON.stringify(mergedData));

      if (onRefreshLogs) onRefreshLogs();
      const newCheckCount = checkCount - savedCheckCount;
      if (onSaveAttendance && newCheckCount > 0) onSaveAttendance(newCheckCount);
      setSavedCheckCount(checkCount);

      openAlert("저장되었습니다! (체험판 모드)", "알림");
      return;
    }

    try {
      const organizationId = userProfile?.organizationId;
      let docRef;

      if (organizationId) {
        docRef = doc(db, "organizations", organizationId, "attendance", currentDate);
      } else {
        docRef = doc(db, "artifacts", appId, "users", auth.currentUser.uid, "attendance", currentDate);
      }

      await setDoc(docRef, dailyAttendance, { merge: true });
      if (onRefreshLogs) onRefreshLogs();

      const newCheckCount = checkCount - savedCheckCount;
      if (onSaveAttendance && newCheckCount > 0) onSaveAttendance(newCheckCount);
      setSavedCheckCount(checkCount);

      openAlert("저장되었습니다! ✅", "알림");
    } catch (error) {
      console.error("Save failed:", error);
      openAlert(`저장 실패: ${error.message}`, "오류");
    }
  };

  return { handleSaveDaily };
}
